import { RootState, ThunkDispatch } from "core-integration/src/store";
import {
  cancelActiveChip,
  cancelProposedChip,
  proposeAvailableChip,
  restoreCancelledChip,
} from "core-integration/src/store/chips/actions";
import {
  getActiveChip,
  getActiveOrProposedAllChipName,
  getActiveOrProposedTeamChipName,
  getPotentialChips,
  teamChipsHaveChanged,
} from "core-integration/src/store/chips/reducers";
import { IPotentialChip } from "core-integration/src/store/chips/types";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import {
  IElement,
  IElementsById,
} from "core-integration/src/store/elements/types";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { fetchEntrySummary } from "core-integration/src/store/entries/thunks";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getNextEvent } from "core-integration/src/store/events/reducers";
import { getFixturesForNextEventByTeam } from "core-integration/src/store/fixtures/reducers";
import { IFixturesForEventByTeam } from "core-integration/src/store/fixtures/types";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import {
  changeCaptain,
  changeViceCaptain,
} from "core-integration/src/store/my-team/actions";
import {
  getMyFormation,
  getMyPicksProposed,
  getMyTeamSavingState,
  hasMyTeamChanged,
  isMyTeamValid,
} from "core-integration/src/store/my-team/reducers";
import {
  actionSubstitution,
  fetchMyTeam,
  saveMyTeam,
} from "core-integration/src/store/my-team/thunks";
import { IPickProposed } from "core-integration/src/store/my-team/types";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ILoggedInPlayer } from "core-integration/src/store/player/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeamsById } from "core-integration/src/store/teams/types";
import {
  formatRawAsISO,
  formatRawAsLocalI18n,
} from "core-integration/src/utils/datetime";
import { range } from "lodash";
import { size } from "polished";
import { Trans, WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import ArrowRight from "../../img/icons/arrow-right.svg?react";
import { ChipName, getAllChipDetails } from "../../utils/chips";
import Alert from "../Alert";
import Box from "../Box";
import Button from "../Button";
import Copy from "../Copy";
import DeadlineBar from "../DeadlineBar";
import Dialog, { DialogButtonItem } from "../Dialog";
import DialogHeading from "../DialogHeading";
import DialogManager from "../DialogManager";
import Entry from "../Entry";
import { FixturesForElement } from "../FixtureForElement";
import Fixtures from "../Fixtures";
import { Main, Secondary, Wrapper } from "../Layout";
import Link from "../Link";
import { ElementRow } from "../Pitch";
import DreamTeam from "../icons/DreamTeam";
// import ShirtSoonAlert from "../ShirtSoonAlert";
import { useEffect, useState } from "react";
import { dateLocales } from "../../i18n";
import { getProposedElements } from "core-integration/src/store/squad/reducers";
import { useBlocker } from "react-router";
import Title from "../Title";
import PageAd from "../PageAd";
import Tooltip, { TooltipLabel } from "../Tooltip";
import UnsavedChangesDialog from "../UnsavedChangesDialog";
import SaveBar from "../squad/SaveBar";
import TabPanel from "../tabs/TabPanel";
import Tabs from "../tabs/Tabs";
import Bench from "./Bench";
import BenchUnit from "./BenchUnit";
import MyTeamTable from "./MyTeamTable";
import PitchFormation from "./PitchFormation";

const StyledPitchWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space[5]};
  padding-top: ${({ theme }) => theme.space[4]};
  background-color: ${({ theme }) => theme.colors.secondaryTwo};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${({ theme }) => theme.radii[2]};
  }
`;

const ChipList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${({ theme }) => theme.space[4]} 0 3.5rem;
  padding: 10px 10px 20px;
  background-color: ${({ theme }) => theme.colors.secondaryTwo};
  list-style-type: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-direction: row;
    border-radius: ${({ theme }) => theme.radii[1]};
  }
`;

const ChipItem = styled.li`
  flex: 1;
  width: 100%;
  padding-inline-end: ${({ theme }) => theme.space[1]};
  padding-inline-start: ${({ theme }) => theme.space[1]};
`;

const Chip = styled.div`
  text-align: center;
`;

const ChipHeading = styled.h3`
  display: inline-block;
  margin-top: ${({ theme }) => theme.space[4]};
  margin-bottom: ${({ theme }) => theme.space[3]};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[5]};
  font-weight: normal;
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: ${({ theme }) => theme.space[3]};
  }
`;

const ChipLink = styled(Link)`
  position: relative;
  display: block;
  width: 100%;
  padding: 0.2rem 2.7rem 0.2rem;
  border: ${({ theme }) => theme.borders[3]};
  border-radius: ${({ theme }) => theme.radii[3]};
  background-color: ${({ theme }) => theme.colors.secondary};
  color: #333;

  &:hover {
    text-decoration: none;
  }
`;

const ChipLinkTextWrap = styled.div`
  display: flex;
  justify-content: center;
  gap: 3px;
  padding: ${({ theme }) => theme.space[1]} 0;
`;

const ChipLinkArrow = styled(ArrowRight)`
  ${size(10)};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  inset-inline-end: ${({ theme }) => theme.space[2]};

  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

const renderPickValue =
  (initProps: {
    elementsById: IElementsById;
    fixturesForNextEventByTeam: IFixturesForEventByTeam;
    teamsById: ITeamsById;
  }) =>
  (pick: IPickLight) => {
    const element = initProps.elementsById[pick.element];
    return (
      <FixturesForElement
        fixtures={initProps.fixturesForNextEventByTeam[element.team]}
        element={element}
        teamsById={initProps.teamsById}
      />
    );
  };

const PlayerActions = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin: 0 auto;
  }
`;

type Props = WithTranslation;

const MyTeam: React.FC<Props> = ({ i18n, t }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const [pickForMenu, setPickForMenu] = useState<IPickProposed | null>(null);

  const player = useSelector(getPlayerData) as ILoggedInPlayer;

  const activeChip = useSelector(getActiveChip);
  const chipInPlayName = useSelector(getActiveOrProposedTeamChipName);
  const chipAllPlayName = useSelector(getActiveOrProposedAllChipName);
  const changed = useSelector(hasMyTeamChanged);
  const chips = useSelector(getPotentialChips);
  const chipsChanged = useSelector(teamChipsHaveChanged);
  const elementsById = useSelector(getElementsById);
  const entry = useSelector((state: RootState) =>
    getEntry(state, player.entry),
  );
  const fixturesForNextEventByTeam = useSelector(getFixturesForNextEventByTeam);
  const formation = useSelector(getMyFormation);
  const nextEvent = useSelector(getNextEvent);
  const picks = useSelector(getMyPicksProposed);
  const savingState = useSelector(getMyTeamSavingState);
  const rules = useSelector(getRules) as IRules;
  const teamsById = useSelector(getTeamsById);
  const valid = useSelector(isMyTeamValid);
  const proposedElements = useSelector(getProposedElements);

  // useBlocker allows us to intercept navigation if a condition is met. Here we use
  // hasChanged so that if team changes have been made we ask the user to confirm
  // they are happy for changes to be lost
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return (
      chipsChanged ||
      (Object.keys(proposedElements).length > 0 &&
        changed &&
        currentLocation.pathname !== nextLocation.pathname)
    );
  });

  const handleShowMenuForPickElement = (element: number) => {
    const matches = picks.filter((p) => p.element === element);
    if (matches.length) {
      setPickForMenu(matches[0]);
    }
  };

  const handleHideMenuForPick = () => {
    setPickForMenu(null);
  };

  const renderDreamTeam = (pick: IPickLight) =>
    elementsById[pick.element].in_dreamteam ? (
      <Link to="/dream-team/">
        <DreamTeam />
      </Link>
    ) : null;

  const action = (
    type: "substitute" | "makeCaptain" | "makeViceCaptain",
    element: number,
  ) => {
    handleHideMenuForPick();
    switch (type) {
      case "substitute":
        dispatch(actionSubstitution(element));
        break;
      case "makeCaptain":
        dispatch(changeCaptain(element));
        break;
      case "makeViceCaptain":
        dispatch(changeViceCaptain(element));
        break;
    }
  };

  const showDialog = (element: IElement) => {
    dispatch(showElementSummary(element.id));
    handleHideMenuForPick();
  };

  const renderMenu = () => {
    const pick = pickForMenu;
    if (!pick) {
      return null;
    }
    const element = elementsById[pick.element];
    const status = pick.subStatus;
    const startMax = rules.squad_squadplay;
    return (
      <Dialog closeDialog={handleHideMenuForPick}>
        <Dialog.Header closeDialog={handleHideMenuForPick}>
          <DialogHeading>
            {`${element.first_name} ${element.second_name}`}
          </DialogHeading>
        </Dialog.Header>
        <Dialog.Body>
          <PlayerActions>
            {status.match(/^(target|)$/) && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("substitute", pick.element)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.menuDialog.switch", "Switch")}
                </Button>
              </DialogButtonItem>
            )}
            {status === "instigator" && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("substitute", pick.element)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.menuDialog.cancel", "Cancel")}
                </Button>
              </DialogButtonItem>
            )}
            {!status && pick.position <= startMax && !pick.is_captain && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("makeCaptain", pick.element)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.menuDialog.makeCaptain", "Make Captain")}
                </Button>
              </DialogButtonItem>
            )}
            {!status && pick.position <= startMax && !pick.is_vice_captain && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("makeViceCaptain", pick.element)}
                  width={1}
                  variant="primary"
                >
                  {t("myTeam.menuDialog.makeViceCaptain", "Make Vice Captain")}
                </Button>
              </DialogButtonItem>
            )}
            <DialogButtonItem>
              <Button
                onClick={() => showDialog(element)}
                width={1}
                variant="primary"
              >
                {t("myTeam.menuDialog.viewInfo", "View Information")}
              </Button>
            </DialogButtonItem>
          </PlayerActions>
        </Dialog.Body>
      </Dialog>
    );
  };

  useEffect(() => {
    dispatch(fetchMyTeam());
    dispatch(fetchEntrySummary(player.entry));
  }, [dispatch, player.entry]);

  const renderChipAction = (c: IPotentialChip) => {
    switch (c.status_for_entry) {
      case "available":
      case "unavailable":
        return (
          <Button
            onClick={() => dispatch(proposeAvailableChip(c.name))}
            disabled={Boolean(chipInPlayName)}
            width={1}
            variant="secondary"
          >
            {t("myTeam.play", "Play")}
          </Button>
        );
      case "proposed":
        return (
          <Button
            variant="primary"
            onClick={() => dispatch(cancelProposedChip(c.name))}
            width={1}
          >
            {t("myTeam.cancel", "Cancel")}
          </Button>
        );
      case "active":
        return (
          <Button
            variant="primary"
            onClick={() => dispatch(cancelActiveChip(c.name))}
            width={1}
          >
            {t("myTeam.cancel", "Cancel")}
          </Button>
        );
      case "cancelled":
        return (
          <Button
            variant="primary"
            onClick={() => dispatch(restoreCancelledChip(c.name))}
            disabled={Boolean(chipInPlayName)}
            width={1}
          >
            {t("myTeam.restore", "Restore")}
          </Button>
        );
      case "played":
        if (!entry) {
          return (
            <>
              <div>{t("myTeam.played", "Played")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
            </>
          );
        }
        return (
          <ChipLink to={`/entry/${entry.id}/event/${c.played_by_entry[0]}`}>
            <ChipLinkTextWrap>
              <div>{t("myTeam.played", "Played")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
              <ChipLinkArrow />
            </ChipLinkTextWrap>
          </ChipLink>
        );
      default:
        return "";
    }
  };

  const renderUnlimitedChipAction = (c: IPotentialChip) => {
    switch (c.status_for_entry) {
      case "available":
      case "unavailable":
        return (
          <DialogManager
            render={(showDialog, handleShow, handleHide) => (
              <>
                <Button
                  onClick={handleShow}
                  disabled={Boolean(chipInPlayName)}
                  width={1}
                  variant="secondary"
                >
                  {t("myTeam.play", "Play")}
                </Button>
                {showDialog && (
                  <Dialog closeDialog={handleHide}>
                    <Dialog.Header closeDialog={handleHide}>
                      <DialogHeading>
                        {t("myTeam.chips.unlimit.name", "Loan Rangers")}
                      </DialogHeading>
                    </Dialog.Header>
                    <Dialog.Body isPadded={true}>
                      <Copy>
                        <p>
                          {t(
                            "myTeam.chips.unlimit.dialog.p1",
                            "The Loan Rangers chip is played when confirming your transfers and can be used once in the first half of the season and once in the second half, as chips reset at the halfway point.",
                          )}
                        </p>
                        <p>
                          {t(
                            "myTeam.chips.unlimit.dialog.p2",
                            "It allows you to make unlimited free transfers and choose how many players you want from a specific team for a single round. At the next deadline, your squad is returned to how it was at the start of the round.",
                          )}
                        </p>
                        <p>
                          <Trans i18nKey="myTeam.chips.unlimit.dialog.p3">
                            Please note: Loan Rangers{" "}
                            <strong>cannot be cancelled </strong> once
                            confirmed.
                          </Trans>
                        </p>
                      </Copy>
                    </Dialog.Body>
                  </Dialog>
                )}
              </>
            )}
          />
        );
      case "active":
        return <Button width={1}>{t("myTeam.active", "Active")}</Button>;
      case "played":
        if (!entry) {
          return (
            <>
              <div>{t("myTeam.active", "Active")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
            </>
          );
        }
        return (
          <ChipLink to={`/entry/${entry.id}/event/${c.played_by_entry[0]}`}>
            <ChipLinkTextWrap>
              <div>{t("myTeam.played", "Played")}</div>
              <div>{`${t("myTeam.round", "Round")} ${
                c.played_by_entry[0]
              }`}</div>
              <ChipLinkArrow />
            </ChipLinkTextWrap>
          </ChipLink>
        );
      default:
        return "";
    }
  };

  if (!entry || !picks.length) {
    return null;
  }
  // Create a new function on each render as fixtures could have changed and
  // need to ensure a render of connected subcomponents
  const _renderPickValue = renderPickValue({
    elementsById,
    teamsById,
    fixturesForNextEventByTeam,
  });
  const benchHeading: Record<string, React.ReactNode> = {
    11: (
      <Tooltip content="Goalkeeper">
        <TooltipLabel>GK</TooltipLabel>
      </Tooltip>
    ),
    12: "1",
    13: "2",
    14: "3",
  };

  const unlimitedChip = chips.filter((c) => c.name === "uteam")[0];
  const chipDetails = getAllChipDetails(t);
  return (
    <>
      <Wrapper>
        <Main>
          <Box mx={2} mb={4}>
            <Title>{t("myTeam.title", "My Team")}</Title>
          </Box>
          <PageAd />
          {blocker.state === "blocked" && (
            <UnsavedChangesDialog
              handleConfirm={() =>
                blocker.state === "blocked" && blocker.proceed()
              }
              handleHide={() => blocker.state === "blocked" && blocker.reset()}
            />
          )}
          {nextEvent && (
            <DeadlineBar
              deadlineISO={formatRawAsISO(nextEvent.deadline_time)}
              deadlineLocal={formatRawAsLocalI18n(
                nextEvent.deadline_time,
                dateLocales[i18n.language],
              )}
              headingText={nextEvent.name}
            />
          )}
          <Box my={2}>
            <Alert type="info">
              {t(
                "myTeam.alerts.captain",
                "To change your captain use the menu which appears when clicking on a player's shirt.",
              )}
            </Alert>
          </Box>
          <StyledPitchWrapper>
            <Tabs centered>
              <TabPanel
                label={t("myTeam.pitchView", "Pitch View")}
                link="pitch"
              >
                <Box mx={-2} pt={4}>
                  <PitchFormation
                    chipName={chipAllPlayName}
                    formation={formation}
                    picks={picks}
                    renderDreamTeam={renderDreamTeam}
                    renderElementMenu={handleShowMenuForPickElement}
                    renderPickValue={_renderPickValue}
                  />
                  <Bench>
                    <ElementRow>
                      {range(rules.squad_squadplay, rules.squad_squadsize).map(
                        (i) => (
                          <BenchUnit
                            key={i}
                            chipName={chipAllPlayName}
                            heading={benchHeading[i]}
                            pick={picks[i]}
                            renderElementMenu={() =>
                              handleShowMenuForPickElement(picks[i].element)
                            }
                            renderDreamTeam={renderDreamTeam}
                            renderPickValue={_renderPickValue}
                          />
                        ),
                      )}
                    </ElementRow>
                  </Bench>
                </Box>
              </TabPanel>
              <TabPanel label={t("myTeam.listView", "List View")} link="list">
                <Box mt={4} mb={4}>
                  <MyTeamTable
                    title={t("myTeam.starters", "Starters")}
                    picks={picks.slice(0, rules.squad_squadplay)}
                    renderElementMenu={handleShowMenuForPickElement}
                  />
                  <MyTeamTable
                    title={t("myTeam.substitutes", "Substitutes")}
                    picks={picks.slice(rules.squad_squadplay)}
                    renderElementMenu={handleShowMenuForPickElement}
                  />
                </Box>
              </TabPanel>
            </Tabs>
          </StyledPitchWrapper>
          {/* <ShirtSoonAlert /> */}
          {activeChip && activeChip.chip_type === "transfer" ? (
            <Box my={2}>
              <Alert type="info">
                <p>
                  {t("myTeam.alerts.transferChip", "{{ chipName }} Active", {
                    chipName: chipDetails[activeChip.name as ChipName].name,
                  })}
                </p>
              </Alert>
            </Box>
          ) : (
            <ChipList>
              {chips
                .filter((c) => ["2capt", "pdbus"].indexOf(c.name) > -1)
                .map((c) => (
                  <ChipItem key={c.name}>
                    <Chip>
                      <Tooltip
                        content={chipDetails[c.name as ChipName].description}
                      >
                        <ChipHeading>
                          {chipDetails[c.name as ChipName].name}
                        </ChipHeading>
                      </Tooltip>
                      {renderChipAction(c)}
                    </Chip>
                  </ChipItem>
                ))}
              {unlimitedChip && (
                <ChipItem>
                  <Chip>
                    <Tooltip
                      content={
                        chipDetails[unlimitedChip.name as ChipName].description
                      }
                    >
                      <ChipHeading>
                        {chipDetails[unlimitedChip.name as ChipName].name}
                      </ChipHeading>
                    </Tooltip>
                    {renderUnlimitedChipAction(unlimitedChip)}
                  </Chip>
                </ChipItem>
              )}
            </ChipList>
          )}
          {savingState === "saved" ? (
            <Box my={2}>
              <Alert type="success">
                {t("myTeam.alerts.teamSaved", "Your team has been saved.")}
              </Alert>
            </Box>
          ) : (
            <Box mx={4}>
              <SaveBar
                hasUnsavedChanges={
                  (changed || chipsChanged) && valid && savingState !== "saving"
                }
                unsavedChangesText={t(
                  "unsavedChanges",
                  "You have unsaved changes",
                )}
              >
                <Button
                  onClick={() => dispatch(saveMyTeam())}
                  disabled={
                    (!changed && !chipsChanged) ||
                    !valid ||
                    savingState === "saving"
                  }
                  width={1}
                >
                  {t("myTeam.saveTeam", "Save Your Team")}
                </Button>
              </SaveBar>
            </Box>
          )}
          {renderMenu()}
          <Fixtures />
        </Main>
        <Secondary>
          <Entry entryId={entry.id} />
        </Secondary>
      </Wrapper>
    </>
  );
};

export default withTranslation()(MyTeam);
